<h1>Enter Regional Ecosystems</h1>
<div class="preamble instructions">
  @if (form.hasError('reRequiredValidationError')) {
    <div class="alert alert-warning mt-4" role="alert">
      <h2><i class="fa fa-exclamation-triangle"></i>No valid regional ecosystems selected</h2>
      At least one valid regional ecosystem must be selected for each available category.
    </div>
  }
</div>

<form [formGroup]="form" class="form">
  <div formArrayName="regionalEcosystemCategoryArray">
    @for (reCategoryControl of getRECategoryArray().controls; track reCategoryControl; let reCategoryGroupName = $index) {
      <div>
        <div [formGroupName]="reCategoryGroupName">
          <ol class="questions">
            <li class="section">
              @if (form.hasError('reSelectedLimitValidationError' + reCategoryControl.value.categoryPurposeId)) {
                <div
                  class="alert alert-warning mt-4" role="alert">
                  <h2><i class="fa fa-exclamation-triangle"></i>Regional ecosystems limit reached</h2>
                  Only 10 regional ecosystems can be selected per category.
                </div>
              }
              <label>
                <h3>{{reCategoryControl.value.category}}</h3>
                <small class="relevance">Up to 10 regional ecosystems that are on this lot on plan can be
                selected.</small>
              </label>
              @for (activity of activities; track activity) {
                <div>
                  <br>
                    @if (!requiresActivity || activity.categoryPurposeId === reCategoryControl.value.categoryPurposeId) {
                      <div>
                        @if (requiresActivity) {
                          <h4>{{ activity.description }}</h4>
                        }
                        @for (reControl of getRegionalEcosystemArray(reCategoryControl).controls; track reControl; let reGroupName = $index) {
                          <div formArrayName="regionalEcosystems"
                            >
                            @if (compareActivities(activity.activityId, reControl.value.regionalEcosystem.activityId)) {
                              <div
                                [formGroupName]="reGroupName">
                                <input type="checkbox" formControlName="checked"
                                  id="re-{{reControl.value.regionalEcosystem.regionalEcosystemId}}-cat-{{reControl.value.regionalEcosystem.categoryPurposeId}}-activity-{{activity.activityId}}" />
                                  <label
                                    for="re-{{reControl.value.regionalEcosystem.regionalEcosystemId}}-cat-{{reControl.value.regionalEcosystem.categoryPurposeId}}-activity-{{activity.activityId}}">
                                    {{ reControl.value.regionalEcosystem.regionalEcosystem }}
                                    @if (reControl.value.checked && !!reControl.value.regionalEcosystem.message && messages.length > 0) {
                                      <small
                                        >
                                        <sup>*{{messages.indexOf(reControl.value.regionalEcosystem.message)
                                        + 1}}</sup>
                                      </small>
                                    }
                                  </label>
                                  <ol class="questions">
                                    @if (reControl.value.checked &&  reControl.value.regionalEcosystem.regionalEcosystem == 'My RE is not in the list') {
                                      <li class="section"
                                        >
                                        <fieldset>
                                          <ol class="questions compact">
                                            @if (getManuallySelectedArray(getRECategoryArrayByCategory(reCategoryControl.value.categoryPurposeId)).hasError('manualReRequiredValidationError' + reCategoryControl.value.categoryPurposeId + activity.activityId)) {
                                              <div
                                                class="alert alert-warning mt-4" role="alert">
                                                <i class="fa fa-exclamation-triangle"></i>
                                                At least one regional ecosystem must be added when "My RE is
                                                not in the list" is selected.
                                              </div>
                                            }
                                            @for (searchResult of searchFailed; track searchResult) {
                                              <div>
                                                @if (searchResult.category == reCategoryControl.value.categoryPurposeId && compareActivities(searchResult.activityId, activity.activityId) && searchResult.failed) {
                                                  <div
                                                    class="alert alert-warning mt-4" role="alert">
                                                    <i class="fa fa-exclamation-triangle"></i>
                                                    This regional ecosystem cannot be cleared for the
                                                    purpose selected.
                                                  </div>
                                                }
                                              </div>
                                            }
                                            <p>
                                              If the regional ecosystem that occurs on the ground is not
                                              in the list, please search for the regional ecosystem to add
                                              to the notification:
                                            </p>
                                            <li>
                                              <input type="text" id="re" placeholder="Regional ecosystem"
                                                #reSearchText />
                                              </li>
                                              <li>
                                                <input class="qg-btn btn-primary" type="submit"
                                                  (click)="addRegionalEcosystem(reSearchText.value, reControl.value.regionalEcosystem)"
                                                  value="Add RE" />
                                                </li>
                                              </ol>
                                            </fieldset>
                                          </li>
                                        }
                                      </ol>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if (showManuallyAddedList(reCategoryControl.value.categoryPurposeId, activity.activityId)) {
                            <div
                              >
                              <br>
                                <small>Manually added:</small>
                                @for (manuallySelectedControl of getManuallySelectedArray(reCategoryControl).controls; track manuallySelectedControl; let manuallySelectedName = $index) {
                                  <div formArrayName="manuallySelected"
                                    >
                                    @if (compareActivities(manuallySelectedControl.value.regionalEcosystem.activityId, activity.activityId)) {
                                      <div [formGroupName]="manuallySelectedName"
                                        >
                                        <input type="checkbox" formControlName="checked"
                                          id="re-{{manuallySelectedControl.value.regionalEcosystem.regionalEcosystemId}}-cat-{{manuallySelectedControl.value.regionalEcosystem.categoryPurposeId}}-activity-{{activity.activityId}}" />
                                          <label
                                            for="re-{{manuallySelectedControl.value.regionalEcosystem.regionalEcosystemId}}-cat-{{manuallySelectedControl.value.regionalEcosystem.categoryPurposeId}}-activity-{{activity.activityId}}">
                                            {{ manuallySelectedControl.value.regionalEcosystem.regionalEcosystem }}
                                            @if (manuallySelectedControl.value.checked && !!manuallySelectedControl.value.regionalEcosystem.message && messages.length > 0) {
                                              <small
                                                >
                                                <sup>*{{messages.indexOf(manuallySelectedControl.value.regionalEcosystem.message)
                                                + 1}}</sup>
                                              </small>
                                            }
                                          </label>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </li>
                      </ol>
                    </div>
                  </div>
                }
              </div>
              @if (messages.length > 0) {
                <div class="alert alert-info mt-4" role="alert">
                  <h2><i class="fa fa-info-circle"></i>Messages</h2>
                  <ol>
                    @for (message of messages; track message) {
                      <li>
                        {{message}}
                      </li>
                    }
                  </ol>
                </div>
              }
              <div class="footer">
                <ul class="actions">
                  <li> <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" /> </li>
                  <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next"
                  in-progress-text="Saving..." /> </em> </li>
                </ul>
                <ul class="actions">
                  <li>
                    <a href="#" (click)="cancel()">Cancel</a>
                  </li>
                </ul>
              </div>
            </form>